<template>
  <div>
    <div class="block-content">
      <div class="col-sm-12 table-responsive">
        <table class="table table-striped table-vcenter">
          <thead>
            <tr role="row">
              <th class="text-center" tabindex="0">
                #
              </th>
              <th class="text-capitalize">
                Email
              </th>
              <th class="text-capitalize">
                Fullname
              </th>
              <th class="text-capitalize">
                Amount
              </th>
              <th class="text-capitalize">
                SSN
              </th>
              <th class="text-capitalize">
                Grant Type
              </th>
              <th class="text-capitalize">
                Status
              </th>


              <th class="text-center text-capitalize">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr role="row" class="odd" v-for="(grant, index) in grants">
              <td class="text-center sorting_1">
                {{ index + 1 }}
              </td>
              <td>
                {{ grant.email }}
              </td>
              <td>
                {{ grant.name }}
              </td>
              <td>{{ grant.currency.symbol }}{{ grant.amount }}</td>
              <td>
                {{ grant.ssn ? grant.ssn : 'Unavailable' }}
              </td>
              
              <td>
                {{ grant.description }}
              </td>
              <td>
                <span class="text-warning" v-if="grant.status == 0"
                  >Pending</span
                >
                <span class="text-danger" v-if="grant.status == 2"
                  >Rejected</span
                >
                <span class="text-success" v-if="grant.status == 1">Approved</span>
              </td>

              <td>
                <a download :href="grant.plink"> Passport</a>
              </td>

              <td>
                <a download :href="grant.dlink"> Document</a>
              </td>

              <td>
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-sm btn-danger mr-2"
                    data-toggle="tooltip"
                    title="Edit"
                    @click.prevent="updateStatus(grant.id, 2)"
                  >
                    Reject
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-success mr-2"
                    data-toggle="tooltip"
                    title="Edit"
                    @click.prevent="updateStatus(grant.id, 1)"
                  >
                    Approve
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    data-toggle="tooltip"
                    title="Delete"
                    @click.prevent="deleteGrant(grant.id)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { RepositoryFactory } from '../../repository/RepositoryFactory';
const UsersRepository = RepositoryFactory.get('users');
export default {
  data() {
    return {
      grants: [],
    };
  },
  methods: {
    async updateStatus(id, type) {
      try {
        await UsersRepository.adminUpdateGrantStatus(id, type);
        await this.fetchGrants();
        toast.fire({
          type: 'success',
          title: 'Grant status updated successfully',
        });
      } catch (error) {
        console.log(error)
        toast.fire({
          type: 'error',
          title: 'Something went wrong',
        });
      }
    },
    async deleteGrant(id) {
      try {
        await UsersRepository.adminDeleteGrant(id);
        toast.fire({
          type: 'success',
          title: 'Grant deleted successfully',
        });
      } catch (error) {
        toast.fire({
          type: 'error',
          title: 'Something went wrong',
        });
      }
    },
    async fetchGrants() {
      try {
        let res = await UsersRepository.adminFetchGrants();
        this.grants = res.data;
      } catch (error) {
        toast.fire({
          type: 'error',
          title: 'Something went wrong',
        });
      }
    },
  },
  created() {
    this.fetchGrants();
  },
};
</script>
